module.exports = __webpack_public_path__ + "img/b80333a.png";